import {
  ProcedureInstructionQueryParams,
  TablesDirectionDataT,
} from "@interfaces/company/procedure";

import fetcher from "@http/fetcher";
import { proceduresQueryKeys } from "./queryKeys";
import { useQuery } from "react-query";

export const useBriefingProceduresQuery = (
  params?: ProcedureInstructionQueryParams,
  isGeneral?: boolean
) => {
  return useQuery(
    proceduresQueryKeys.allBriefingProcedures(params),
    async () => {
      const resp = await fetcher.modified.get<TablesDirectionDataT[]>(
        "/procedures-control/briefing",
        {
          params,
        }
      );

      return resp.data;
    },
    {
      enabled: !isGeneral,
      keepPreviousData: true,
    }
  );
};

export const useBriefingProcedureGeneralsQuery = (
  params?: ProcedureInstructionQueryParams,
  isGeneral?: boolean
) => {
  return useQuery(
    proceduresQueryKeys.allBriefingProcedures(params),
    async () => {
      const resp = await fetcher.get<TablesDirectionDataT[]>(
        `companies/procedures-control/briefing`,
        {
          params,
        }
      );

      return resp.data;
    },
    {
      enabled: isGeneral,
      keepPreviousData: true,
    }
  );
};
